module.exports = __webpack_public_path__ + "img/plus_sign.36aa875b.svg";